module.exports = __webpack_public_path__ + "media/images/news/voip-gpt-transliteration-bdfdb3017ad5938cb1c39c4d2b917a34.gif";